"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAddress = exports.cleanAddress = void 0;
const cleanAddress = (address) => {
    return typeof address === 'string' ? address.trim() : '';
};
exports.cleanAddress = cleanAddress;
const validateAddress = (address) => {
    return typeof address === 'string' && address.length > 0;
    ;
};
exports.validateAddress = validateAddress;
//# sourceMappingURL=addressValidator.js.map